const faqs = [
  {
    q: '天天影院的剧集需要付费观看吗？',
    a: '天天影院所有剧集均为免费在线观看，无需付费、无需注册会员。我们致力于为追剧爱好者提供最新电视剧全集资源，国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源全部免费开放。',
  },
  {
    q: '剧集更新速度快吗？多久更新一次？',
    a: '天天影院每日同步更新最新电视剧全集内容。热门剧集播出后数小时内即可上线，确保追剧无需等待。我们拥有专业的内容整理团队，第一时间收录最新剧集资源。',
  },
  {
    q: '播放画质怎么样？会不会经常缓冲？',
    a: '天天影院提供高清画质播放，优化了播放链路，确保流畅不缓冲。无论是国产剧全集在线、韩剧全集免费还是美剧全集播放，都能获得稳定清晰的观看体验。',
  },
  {
    q: '需要下载 App 或注册账号吗？',
    a: '不需要。天天影院支持浏览器直接访问观看，无需下载 App 或注册账号。打开网页即可开始追剧，方便快捷。同时也提供移动端适配，手机和平板都能流畅使用。',
  },
  {
    q: '天天影院支持哪些设备和浏览器？',
    a: '天天影院兼容主流浏览器（Chrome、Safari、Edge、Firefox），支持桌面电脑、笔记本、平板和手机访问。界面已针对不同屏幕尺寸做了自适应优化。',
  },
  {
    q: '站内剧集资源覆盖哪些类型？',
    a: '天天影院覆盖国产剧全集在线、韩剧全集免费、美剧全集播放、日剧全集资源四大核心品类，同时包含动漫、综艺、纪录片等多种类型，共12个内容分类，满足各类追剧需求。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100 px-3 py-1 rounded-full mb-3">
              答疑解惑
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">关于天天影院的常见疑问都在这里</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <details
                key={i}
                className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
                open={i === 0}
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {faq.q}
                  </h3>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}